import {observer} from 'mobx-react-lite';
import styled from 'styled-components';
import ReactEcharts from 'echarts-for-react';
import moment from 'moment';
import {graphic} from 'echarts';
import {useStore} from '@/store/root-store';
import numeral from 'numeral';
import {Badge} from 'antd';
import React from 'react';
import {renderToString} from 'react-dom/server';
import {SkeletonRingLoader} from '@/components/common-components';
import {EmptyStateKeDetail} from './emptyStateKe';
import {ChartOverlayBanner} from '../../ke-common-components/chartOverlayBanner';
import {getDomain, isPublicKeywordResearcherV2} from '@/utils/url';
import {linkgraphDomains} from '@/utils/router';

interface Props {
  isFullWidth?: boolean;
  className?: string;
}

export const HistoricalChart:React.FC<Props> = observer(({isFullWidth=false, className=''}) => {
  const {keywordResearcherV2: {keywordDetails: {getKeywordDetailsData, loadingKeywordMainDetails}}} = useStore('');
  const chartData = getKeywordDetailsData?.metrics?.trendData ? getKeywordDetailsData?.metrics?.trendData : [];
  const currentDomain = getDomain(window.location.hostname);
  const isWhiteLabelDomain = !linkgraphDomains.includes(currentDomain);
  const tooltipFormatter = function(series: any) {
    const element = (
      <div>
        <span style={{fontWeight: 'bold'}}>
          {moment(series[0].axisValue).format('MMM DD, YYYY')}
        </span>
        {series?.reverse()?.map((item, index: number) => {
          return (
            <div key={index}>
              <div >
                <span >
                  {/* {moment(item.axisValue).format('MMM DD, YYYY')} */}
                </span>
                <span>
                  <Badge color={item.color} dot size='small' />
                  {item.seriesName}: {numeral(item.data).format('0.[0][a]').toUpperCase()}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    );
    return renderToString(element);
  };
  return (
    <Container className={className} isFullWidth={isFullWidth}>
      <Heading>HISTORICAL SEARCH VOLUME</Heading>
      {loadingKeywordMainDetails ?
        <div style={{padding: 50}}>
          <SkeletonRingLoader />
        </div> :
        ((!loadingKeywordMainDetails && chartData?.length) ? <ChartContainer>
          {(isPublicKeywordResearcherV2() && isWhiteLabelDomain ) ? ' ' : isPublicKeywordResearcherV2() && <ChartOverlayBanner />}
          <ReactEcharts
            style={{height: '100%', width: '100%', minHeight: '220px'}}
            option = {{
              xAxis: {
                type: 'category',
                boundaryGap: false,
                axisLabel: {
                  formatter: value => {
                    return moment(value).format('MMM');
                  },
                },
                axisTick: {
                  alignWithLabel: true,
                },
                vaxix: 0,
                min: 0,
                data: chartData?.map(item=>item?.date),
              },
              grid: {
                left: 45,
                right: 12,
                bottom: 20,
                top: 15,
              },
              yAxis: {
                type: 'value',
                show: true,
                axisTick: {
                  show: true,
                }, splitLine: {
                  lineStyle: {
                    color: '#bcbcbf',
                    type: 'dashed',
                  },
                },
                axisLabel: {
                  formatter: value => numeral(value).format('0.[0][a]').toUpperCase(),
                },
              },
              series: [
                {
                  name: 'Search volume',
                  type: 'line',
                  color: '#FF8536',
                  symbol: 'none',
                  areaStyle: {
                    color: new graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#FF85361A',
                    }, {
                      offset: 0.8,
                      color: '#ffffff',
                    }]),

                  },
                  data: chartData?.map(item=>item?.volume),
                },
              ],
              tooltip: {
                trigger: 'axis',
                formatter: tooltipFormatter,
                confine: true,
              },
            }}/>
        </ChartContainer> :
          <EmptyStateKeDetail icon={true} imgText={'/img/backgroundfasearch.svg'} text={'Search Volume data is unavailable or missing.'} description={'We couldn’t find this keyword in our database'}/>
        )}
    </Container>
  );
});

const ChartContainer = styled.div`
  height: calc(100% - 25px);
  width: 100%;
  position: relative;
`;

const Container = styled.div<{isFullWidth: boolean}>`
  background: #FFFFFF;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 3px 2px rgba(0, 0, 0, 0.02);
  border-radius: 10px;
  width: ${p => p.isFullWidth ? '100%' : '70%'};
  padding: 22px 25px 15px 25px;
`;

const Heading = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  text-transform: uppercase;
  color: #121212;
`;
